var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { isEmpty, orderBy } from "lodash";
import { useCallback, useContext, useEffect, useRef, useState, } from "react";
import { Tooltip } from "react-bootstrap";
import { refreshNetPosition } from "src/redux/reducers/common-reducer";
import { marginUpdate } from "src/redux/reducers/non-persist";
import { captureCleverTabAnalytics } from "src/utils/analytics";
import { SESSION_KEYS, getDataFromSession, setDataInSession, } from "src/utils/session-storage";
import { checkLogin, createBulkOrderRequest, getMarketStatus, preOrdMarginCalculationBulkV3, scriptDetailsForFOOrder, } from "../../apis/dashboard";
import StepNumberInput from "../../components/inputs/step-number-input";
import SwitchButton from "../../components/switch-button/switch";
import { useAppDispatch, useAppSelector } from "../../hooks/redux";
import { closeBulkOrderPlacement, closeSelectedExpiry, openAddToBasketModal, openGuestLoginModal, openOrderSummary, setBulkOrderDataList, setSummaryOrdersDataList, } from "../../redux/reducers/modals";
import { APP_SOURCE, CURRENCY_DECIMAL_LENGTH_LIMIT, DECIMAL_LENGTH_LIMIT, } from "../../utils/constant";
import { classifyBulkOrderType, convertNumberToShortText, generateRandomRemoteId, getBase64EncryptedText, getChangeAndChangePercentage, getDefaultDateFormat, getSegmentAndProductType, getTextColorFromString, handleDecimalLimit, intComma, splitAndGetDetailsFromLongName, } from "../../utils/methods";
import { heartBeatData, subscribeToData } from "../../utils/websocketwrapper";
import styles from "./bulk-order.module.scss";
import moment from "moment";
import { ThemeContext } from "src/contexts/theme-context";
import ActivateSegment from "src/components/activate-segment/activate-segment";
import TripleToggleSwitch from "src/components/triple-toggle-switch/triple-toggle-switch";
import Shimmer from "src/components/loader/shimmer";
const componentName = "BulkOrder";
const BulkOrder = (props) => {
    // const openFeedWsHeartBeat = useAppSelector(
    //   (state) => state.openFeedWs.heartBeat
    // );
    // const [isSocketSubRequired, setSocketSubRequired] = useState(false);
    var _a;
    const ltpRef = useRef([]);
    const [combinedPrem, setCombinedPrem] = useState(0);
    const openFeedWsMsg = useAppSelector((state) => state.openFeedWs.message);
    const [bulkDataList, setBulkDataList] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [existingPositionChecked, setExistingPositionChecked] = useState(false);
    const [availableMargin, setAvailableMargin] = useState(0);
    const [requiredMargin, setRequiredMargin] = useState(0);
    const [isMarketStatusLoading, setMarketStatusLoading] = useState(false);
    // const [strikeDifferenceForScript, setStrikeDifferenceForScript] =
    //   useState<number>(0);
    const [updateMargin, setUpdateMargin] = useState(false);
    const [sensibullModal, setSensibullModal] = useState(false);
    const [sensiBulUrl, setSensiBulUrl] = useState("");
    const [enableStrategyRoute, setEnableStrategyRoute] = useState(false);
    const [userMarketEnabled, setUserMarketEnabled] = useState(getDataFromSession(SESSION_KEYS.USERMARKETENABLED) || {});
    const [lotMultiplier, setLotMultiplier] = useState(0);
    const dispatch = useAppDispatch();
    const theme = useContext(ThemeContext);
    const closeModal = () => {
        dispatch(closeBulkOrderPlacement());
        dispatch(marginUpdate(true));
    };
    const tripleToggleOptions = {
        buySell: ["B", "C", "S"],
        delInt: ["Del", "C", "Int"],
        mktLmt: ["Limit", "C", "Market"],
    };
    const [selectedMktLmtOption, setSelectedMktLmtOption] = useState(tripleToggleOptions.mktLmt.indexOf(classifyBulkOrderType(props.BulkOrderData, "AtMarket", [true, false], ["Market", "Limit", "C"])));
    const [selectedBuySellOption, setSelectedBuySellOption] = useState(tripleToggleOptions.buySell.indexOf(classifyBulkOrderType(props.BulkOrderData, "isBuy", [true, false], ["B", "S", "C"])));
    const [selectedDelIntOption, setSelectedDelIntOption] = useState(tripleToggleOptions.delInt.indexOf(classifyBulkOrderType(props.BulkOrderData, "IsIntraday", [true, false], ["Int", "Del", "C"])));
    const indicesNotAvailableOnSensibull = ["SENSEX", "MIDCPNIFTY"];
    const [bulkOrderSummary, setBulkOrderSummary] = useState([]);
    // const bulkOrderData = useAppSelector((state) => {
    //   return state.modals.bulkOrderPlacement;
    // });
    function getTotalCountByKey(keyName, data) {
        let count = 0;
        data.forEach((data, index) => {
            if (data[keyName]) {
                count++;
            }
        });
        return count;
    }
    const updateMarketEnabled = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            if ((userMarketEnabled === null || userMarketEnabled === void 0 ? void 0 : userMarketEnabled.AllowNseDeriv) === "N") {
                const response = yield checkLogin();
                const marketStatusYesNo = {};
                const Obj = response.data.body;
                Object.entries(Obj).map(([key, value]) => {
                    if (key.substring(0, 5) == "Allow")
                        marketStatusYesNo[key] = value;
                });
                setUserMarketEnabled(marketStatusYesNo);
                setDataInSession(SESSION_KEYS.USERMARKETENABLED, marketStatusYesNo, true);
            }
        }
        catch (err) {
            console.error(err);
        }
    });
    useEffect(() => {
        updateMarketEnabled();
    }, []);
    const isBuyButtonVisible = () => {
        var _a;
        if (userMarketEnabled &&
            (userMarketEnabled === null || userMarketEnabled === void 0 ? void 0 : userMarketEnabled.AllowNseDeriv) === "N" &&
            ((_a = bulkDataList[0]) === null || _a === void 0 ? void 0 : _a.ExchangeType) != "C") {
            return false;
        }
        return true;
    };
    const getScripDetails = (sValue) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            if (sValue.lotSize == 0 || sValue.DQty == 0) {
                const responseData = yield scriptDetailsForFOOrder(sValue.Exchange, sValue.ExchangeType, sValue.ScripCode);
                bulkDataList.forEach((boData, i) => {
                    if (sValue.ScripCode == boData.ScripCode) {
                        if ((responseData === null || responseData === void 0 ? void 0 : responseData.data) && (responseData === null || responseData === void 0 ? void 0 : responseData.data.Status) == 0) {
                            boData.lotSize =
                                boData.openedFrom &&
                                    !boData.openedFrom.includes("Expanded") &&
                                    boData.Qty
                                    ? boData.Qty
                                    : responseData.data.MktLot; // LotSize Update
                            boData.Qty =
                                boData.openedFrom &&
                                    !boData.openedFrom.includes("Expanded") &&
                                    boData.Qty
                                    ? boData.Qty
                                    : responseData.data.MktLot;
                            boData.DQty = responseData.data.MktLot;
                            boData.errorMessage = "";
                            // }
                        }
                        else {
                            boData.errorMessage = responseData.data.Message;
                        }
                    }
                });
                setBulkDataList(bulkDataList);
            }
        }
        catch (err) {
            console.error(err);
        }
        finally {
        }
    });
    useEffect(() => {
        const cloneBulkData = JSON.parse(JSON.stringify(props.BulkOrderData));
        setBulkDataList(cloneBulkData);
        // setSocketSubRequired(true);
        // fetchDifferenceOfRate(
        //   splitAndGetDetailsFromLongName(cloneBulkData[0].Name).name,
        //   cloneBulkData
        // );
    }, [props.BulkOrderData]);
    const generateSensibullUrl = () => {
        const payload = {};
        bulkDataList.forEach((singleEle) => {
            if (singleEle.Exchange === "N" && singleEle.ExchangeType === "D") {
                const scriptSplitName = splitAndGetDetailsFromLongName(singleEle.Name);
                let finalExpiry;
                if (scriptSplitName.expiry) {
                    finalExpiry = moment(scriptSplitName.expiry).format("YYYY-MM-DD");
                }
                const scripTypeObj = getSegmentAndProductType(singleEle.Name, singleEle.Exchange, singleEle.ExchangeType);
                const ord = singleEle.AtMarket ? "M" : "L";
                const qty = singleEle.isBuy ? singleEle.Qty : -1 * singleEle.Qty;
                const objData = {
                    exp: finalExpiry,
                    ins: scripTypeObj.subPType,
                    strike: scriptSplitName.strikeRate || undefined,
                    ord: ord,
                    price: singleEle.LastTradePrice,
                    qty: qty,
                    product: "2",
                };
                if (!payload[scriptSplitName.name]) {
                    payload[scriptSplitName.name] = [objData];
                }
                else {
                    payload[scriptSplitName.name].push(objData);
                }
            }
        });
        const jsonPayload = JSON.stringify(payload);
        const base64String = getBase64EncryptedText(jsonPayload); //btoa
        const redirectParams = `widget/builder/basket_page?basket_data=${base64String}&theme=${theme.theme == "dark" ? "dark" : "light"}&broker=3`;
        const encodedParams = encodeURIComponent(redirectParams);
        const url = `https://sensibull.5paisa.com/?redirect_target=insights_widget&redirect_to=${encodedParams}`;
        setSensiBulUrl(url);
    };
    useEffect(() => {
        if (bulkDataList.length > 0) {
            if (!isLoading) {
                getAllScripDetails();
            }
            if (bulkDataList[0].afterMarketHours == undefined &&
                !isMarketStatusLoading) {
                setMarketStatusLoading(true);
                //getMarketStatusCallback();
            }
            validateStrategyData();
        }
    }, [bulkDataList]);
    const getAllScripDetails = () => __awaiter(void 0, void 0, void 0, function* () {
        const promiseList = [];
        bulkDataList.forEach((scrip, index) => {
            if (scrip.lotSize == 0 || scrip.DQty == 0) {
                promiseList.push(getScripDetails(bulkDataList[index]));
            }
        });
        if (promiseList.length > 0) {
            setLoading(true);
            yield Promise.all(promiseList);
            setLoading(false);
        }
    });
    // useEffect(() => {
    //   if (bulkDataList.length > 0 && isSocketSubRequired) {
    //     sendWsMessage(openFeedWsHeartBeat, bulkDataList);
    //     setSocketSubRequired(false);
    //   }
    // }, [openFeedWsHeartBeat, bulkDataList, isSocketSubRequired]);
    const sendWsMessage = (heartBeatMessage, bulkDataList) => {
        if (isEmpty(bulkDataList)) {
            return;
        }
        const method1 = {
            Method: "MarketFeedV3",
            Operation: "Subscribe",
            ClientCode: clientCode,
            MarketFeedData: bulkDataList.map((singleElement) => {
                return {
                    ScripCode: singleElement.ScripCode,
                    Exch: singleElement.Exchange,
                    ExchType: singleElement.ExchangeType,
                };
            }),
        };
        if (heartBeatMessage) {
            heartBeatData(method1, componentName, () => { });
        }
        else {
            subscribeToData(method1, componentName, () => { });
        }
    };
    const clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
    const changeBuySell = useCallback((isBuy, index) => {
        const cloneBulkData = JSON.parse(JSON.stringify(bulkDataList));
        cloneBulkData.forEach((boData, i) => {
            //index -1 used to toggle all items in bulk order to Buy Sell
            if (index === -1) {
                //Logic to toggle all
                boData.isBuy = isBuy;
                cloneBulkData[i].sltErrorMessage = slErrorMsg(boData, false);
            }
            //Logic to toggle single item
            else if (i == index) {
                boData.isBuy = !boData.isBuy;
                cloneBulkData[i].sltErrorMessage = slErrorMsg(boData, false);
                // setAllBuySell("C");
                setSelectedBuySellOption(1);
            }
        });
        const totalBuy = getTotalCountByKey("isBuy", cloneBulkData);
        if (totalBuy === bulkDataList.length) {
            setSelectedBuySellOption(0);
        }
        if (totalBuy === 0) {
            setSelectedBuySellOption(2);
        }
        setBulkDataList(cloneBulkData);
        setUpdateMargin(true);
    }, [bulkDataList]);
    const changeOrderType = useCallback((value, index) => {
        const cloneBulkData = JSON.parse(JSON.stringify(bulkDataList));
        cloneBulkData.forEach((boData, i) => {
            if (index === -1) {
                boData.IsIntraday = value;
            }
            else if (i == index) {
                boData.IsIntraday = !boData.IsIntraday;
                setSelectedDelIntOption(1);
            }
        });
        const totalIntOrder = getTotalCountByKey("IsIntraday", cloneBulkData);
        if (totalIntOrder === bulkDataList.length) {
            setSelectedDelIntOption(2);
        }
        if (totalIntOrder === 0) {
            setSelectedDelIntOption(0);
        }
        setBulkDataList(cloneBulkData);
    }, [bulkDataList]);
    const changeOrderQty = useCallback((data, index) => {
        const cloneBulkData = JSON.parse(JSON.stringify(bulkDataList));
        let qty = 0;
        cloneBulkData.forEach((boData, i) => {
            if (i == index) {
                boData.Qty = data;
            }
        });
        setBulkDataList(cloneBulkData);
        cloneBulkData.forEach((item) => {
            if (item.Qty > 0) {
                qty++;
            }
        });
        if (qty === cloneBulkData.length) {
            setUpdateMargin(true);
        }
    }, [bulkDataList]);
    const onBulkPriceChange = useCallback((value, index) => {
        if (value.length < 10) {
            const cloneBulkData = JSON.parse(JSON.stringify(bulkDataList));
            cloneBulkData.forEach((boData, i) => {
                if (i == index) {
                    boData.Price = handleDecimalLimit(value, cloneBulkData[i].exchangeType == "U"
                        ? CURRENCY_DECIMAL_LENGTH_LIMIT
                        : DECIMAL_LENGTH_LIMIT);
                    cloneBulkData[i].sltErrorMessage = slErrorMsg(boData, false);
                }
            });
            setBulkDataList(cloneBulkData);
            setUpdateMargin(true);
        }
    }, [bulkDataList]);
    useEffect(() => {
        if (bulkDataList.length > 0 && selectedDelIntOption !== 1) {
            selectedDelIntOption === 0
                ? changeOrderType(false, -1)
                : changeOrderType(true, -1);
        }
    }, [selectedDelIntOption]);
    const onMarketLimitChange = useCallback((value, index, shouldUpdateAllValues) => {
        const cloneBulkData = JSON.parse(JSON.stringify(bulkDataList));
        cloneBulkData.forEach((boData, i) => {
            if (index === -1) {
                cloneBulkData[i].AtMarket = value;
                if (shouldUpdateAllValues) {
                    cloneBulkData[i].Price = value
                        ? 0
                        : Number(handleDecimalLimit(cloneBulkData[i].LastTradePrice + "", cloneBulkData[i].exchangeType == "U"
                            ? CURRENCY_DECIMAL_LENGTH_LIMIT
                            : DECIMAL_LENGTH_LIMIT));
                }
                cloneBulkData[i].sltErrorMessage = slErrorMsg(boData, false);
            }
            else if (i == index) {
                cloneBulkData[i].AtMarket = !cloneBulkData[i].AtMarket;
                cloneBulkData[i].Price === value
                    ? Number(handleDecimalLimit(cloneBulkData[i].LastTradePrice + "", cloneBulkData[i].exchangeType == "U"
                        ? CURRENCY_DECIMAL_LENGTH_LIMIT
                        : DECIMAL_LENGTH_LIMIT))
                    : Number(handleDecimalLimit(cloneBulkData[i].LastTradePrice + "", cloneBulkData[i].exchangeType == "U"
                        ? CURRENCY_DECIMAL_LENGTH_LIMIT
                        : DECIMAL_LENGTH_LIMIT));
                cloneBulkData[i].sltErrorMessage = slErrorMsg(boData, false);
                setSelectedMktLmtOption(1);
            }
        });
        const totalMktOrder = getTotalCountByKey("AtMarket", cloneBulkData);
        if (totalMktOrder === bulkDataList.length) {
            setSelectedMktLmtOption(2);
        }
        if (totalMktOrder === 0) {
            setSelectedMktLmtOption(0);
        }
        setBulkDataList(cloneBulkData);
        setUpdateMargin(true);
    }, [bulkDataList]);
    const stopLossChange = useCallback((value, index) => {
        const cloneBulkData = JSON.parse(JSON.stringify(bulkDataList));
        cloneBulkData.forEach((boData, i) => {
            if (i == index) {
                cloneBulkData[i].IsStopLossOrder = value;
                cloneBulkData[i].StopLossPrice = cloneBulkData[i].StopLossPrice
                    ? cloneBulkData[i].StopLossPrice
                    : 0;
                cloneBulkData[i].sltErrorMessage = slErrorMsg(boData, false);
            }
        });
        setBulkDataList(cloneBulkData);
    }, [bulkDataList]);
    const triggerStopLosss = useCallback((value, index) => {
        const cloneBulkData = JSON.parse(JSON.stringify(bulkDataList));
        cloneBulkData.forEach((boData, i) => {
            if (i == index) {
                boData.StopLossPrice = value;
                cloneBulkData[i].sltErrorMessage = slErrorMsg(boData, true);
            }
        });
        setBulkDataList(cloneBulkData);
    }, [bulkDataList]);
    const slErrorMsg = (singleElement, checkZero) => {
        let errorMessage = "";
        if (singleElement.StopLossPrice === "") {
            return "Stop loss is compulsory";
        }
        if (singleElement.IsStopLossOrder) {
            if (singleElement.StopLossPrice === 0) {
                errorMessage = "Stoploss cannot be 0";
            }
            else if ((checkZero && isEmpty(singleElement.StopLossPrice)) ||
                (checkZero && singleElement.StopLossPrice == 0)) {
                errorMessage = "Stop loss is compulsory";
            }
            else if (singleElement.StopLossPrice < 0) {
                errorMessage = "Invalid StopLoss";
            }
            else if (!singleElement.AtMarket) {
                if (singleElement.isBuy &&
                    singleElement.StopLossPrice >= parseFloat(singleElement.Price)) {
                    errorMessage = "Stop loss cannot be greater than price";
                    // returnValue = false;
                }
                else if (!singleElement.isBuy &&
                    singleElement.StopLossPrice <= parseFloat(singleElement.Price)) {
                    errorMessage = "Stop loss cannot be less than price";
                }
                else {
                    errorMessage = "";
                }
            }
            else {
                errorMessage = "";
            }
        }
        else {
            errorMessage = "";
        }
        return errorMessage;
    };
    const validity = new Date();
    validity.setHours(23);
    validity.setMinutes(59);
    validity.setSeconds(59);
    validity.setMilliseconds(999);
    const getMarketStatusCallback = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const response = yield getMarketStatus();
            if (response.data.body.Status == 0) {
                response.data.body.Data.forEach((singleElement) => {
                    bulkDataList.forEach((singleOrderData) => {
                        if (singleElement.ExchType == singleOrderData.ExchangeType &&
                            singleOrderData.Exchange == singleElement.Exch) {
                            if (singleElement.MarketStatus == "Open") {
                                singleOrderData.afterMarketHours = "N";
                            }
                            else {
                                singleOrderData.afterMarketHours = "Y";
                            }
                        }
                    });
                });
            }
            setMarketStatusLoading(false);
        }
        catch (error) {
            console.error(error);
            setMarketStatusLoading(false);
        }
    });
    useEffect(() => {
        if (openFeedWsMsg) {
            updateOptionChain(openFeedWsMsg);
        }
    }, [openFeedWsMsg]);
    const updateOptionChain = (update) => {
        if (update == undefined) {
            return;
        }
        let newScripDetails = [];
        if (bulkDataList.length == 0)
            return;
        newScripDetails = [...bulkDataList];
        if (Array.isArray(update)) {
            update = update[0];
        }
        if ((update === null || update === void 0 ? void 0 : update.Details) === undefined && (update === null || update === void 0 ? void 0 : update.OpenInterest) === undefined) {
            newScripDetails.forEach((singleScrip) => {
                if (singleScrip.ScripCode == (update === null || update === void 0 ? void 0 : update.Token)) {
                    singleScrip.LastTradePrice = update.LastRate;
                    singleScrip.prevClose = update.PClose;
                    singleScrip.Price =
                        singleScrip.Price === undefined
                            ? update.LastRate + ""
                            : singleScrip.Price;
                }
            });
            setBulkDataList(newScripDetails);
        }
    };
    const commonLtpCallback = (ltp, prevClose, changePercentObj, index) => {
        return (_jsxs("div", { children: [_jsx("td", { children: _jsx("div", Object.assign({ className: styles.ltpWidth }, { children: ltp })) }), _jsx("td", { children: _jsxs("div", Object.assign({ className: `${styles.ltpDiffWidth} d-flex` }, { children: [(changePercentObj === null || changePercentObj === void 0 ? void 0 : changePercentObj.differenceValue) ? (changePercentObj === null || changePercentObj === void 0 ? void 0 : changePercentObj.differenceValue) : (_jsx(Shimmer, {})), " ", changePercentObj === null || changePercentObj === void 0 ? void 0 : changePercentObj.percentageValue] })) })] }));
    };
    const executeOrder = (inputBulkData) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const bulkPayLoad = [];
            setLoading(true);
            const cloneBulkData = orderBy([...inputBulkData], ["isBuy"], "desc");
            cloneBulkData.forEach((singleBulk, index) => {
                const payload = {
                    ClientCode: clientCode,
                    OrderFor: "P",
                    Exchange: singleBulk.Exchange,
                    ExchangeType: singleBulk.ExchangeType,
                    ScripCode: singleBulk.ScripCode,
                    OrderType: singleBulk.isBuy ? "BUY" : "SELL",
                    AtMarket: singleBulk.AtMarket,
                    Price: singleBulk.AtMarket == true ? 0 : singleBulk.Price,
                    DisQty: 0,
                    IsStopLossOrder: singleBulk.IsStopLossOrder,
                    StopLossPrice: singleBulk.IsStopLossOrder
                        ? singleBulk.StopLossPrice
                        : 0,
                    IOCOrder: false,
                    IsIntraday: singleBulk.IsIntraday,
                    AHPlaced: singleBulk.afterMarketHours
                        ? singleBulk.afterMarketHours
                        : "Y",
                    ValidTillDate: `${validity.getTime()}`,
                    iOrderValidity: 0,
                    OrderID: 2,
                    Qty: singleBulk.Qty,
                    TradedQty: "0",
                    OrderDateTime: `${new Date().getTime()}`,
                    RemoteOrderID: generateRandomRemoteId(),
                    ExchOrderID: 0,
                    // PublicIP: "",
                    OrderRequesterCode: clientCode,
                    AppSource: APP_SOURCE,
                    LastTradePrice: singleBulk.LastTradePrice,
                    prevClose: singleBulk.prevClose,
                    openedFrom: "bulkOrder",
                    lotMultiplier: lotMultiplier,
                };
                bulkPayLoad.push(payload);
            });
            // bulkPayLoad = orderBy(bulkPayLoad, ["OrderType"], "asc");
            const reqJson = {
                ClientCode: clientCode,
                AppSource: APP_SOURCE,
                OrderRequestData: bulkPayLoad,
            };
            const response = yield createBulkOrderRequest(reqJson);
            dispatch(setSummaryOrdersDataList(reqJson.OrderRequestData));
            if (response.data.body.Status == 0) {
                dispatch(closeBulkOrderPlacement());
                const orderResponseArray = [];
                response.data.body.OrderResponseData.forEach((singleElement, i) => {
                    var _a;
                    const correspondingReqElement = bulkPayLoad[i];
                    const nameBreakup = splitAndGetDetailsFromLongName(cloneBulkData[i].Name);
                    if (correspondingReqElement) {
                        orderResponseArray.push(Object.assign(Object.assign({}, singleElement), { name: nameBreakup.name, expiry: nameBreakup.expiry, scripType: nameBreakup.scripType, strikeRate: nameBreakup.strikeRate, IsIntraday: correspondingReqElement.IsIntraday, OrderType: cloneBulkData[i].isBuy ? "BUY" : "SELL", Qty: correspondingReqElement.Qty, isStratzy: (_a = cloneBulkData[i]) === null || _a === void 0 ? void 0 : _a.isStratzy }));
                    }
                });
                dispatch(openOrderSummary({
                    orderResponseData: orderResponseArray,
                }));
                dispatch(marginUpdate(true));
                dispatch(closeSelectedExpiry());
            }
            dispatch(refreshNetPosition(true));
            captureCleverTabAnalytics("Smart Order from Bulk", {
                eventName: "Smart Order from Bulk",
            });
        }
        catch (error) {
            console.error("Error ", error);
        }
        finally {
            setLoading(false);
            // marginUpdate(true);
            // dispatch(marginUpdate(true));
        }
    });
    const isDataValid = (bData) => {
        if (isLoading) {
            return false;
        }
        let returnValue = true;
        if (bData.length == 0) {
            returnValue = false;
        }
        bData.forEach((singleElement) => {
            if (!singleElement.AtMarket) {
                if (!singleElement.Price || Number(singleElement.Price) <= 0) {
                    returnValue = false;
                }
            }
            if (singleElement.Qty <= 0) {
                returnValue = false;
            }
            if (!isEmpty(singleElement.qtyErrorMessage)) {
                returnValue = false;
            }
            if (singleElement.IsStopLossOrder) {
                if (isEmpty(singleElement.StopLossPrice) ||
                    singleElement.StopLossPrice <= 0) {
                    returnValue = false;
                }
                else if (!singleElement.AtMarket) {
                    if ((singleElement.isBuy &&
                        singleElement.StopLossPrice >= parseFloat(singleElement.Price)) ||
                        (!singleElement.isBuy &&
                            singleElement.StopLossPrice <= parseFloat(singleElement.Price))) {
                        returnValue = false;
                    }
                }
            }
            if (singleElement.lotSize == undefined || singleElement.lotSize <= 0) {
                returnValue = false;
            }
        });
        return returnValue;
    };
    const renderTooltip = (apiMessage) => {
        if (!isEmpty(apiMessage))
            return _jsx(Tooltip, Object.assign({ id: "button-toolTip" }, { children: apiMessage }));
        else
            return _jsx(_Fragment, {});
    };
    const saveBulkOrder = () => {
        const nameBreakup = splitAndGetDetailsFromLongName(bulkDataList[0].Name);
        const newBulkData = bulkDataList.map((v, index) => (Object.assign(Object.assign({}, v), { expiry: moment(nameBreakup.expiry).format("YYYY-MM-DD"), symbol: nameBreakup.name, index: index })));
        dispatch(setBulkOrderDataList(newBulkData));
    };
    const deleteSingleBulkOrder = (indexValue) => {
        const filteredBulkDataList = bulkDataList.filter((data, index) => {
            return index !== indexValue;
        });
        const totalBuy = getTotalCountByKey("isBuy", filteredBulkDataList);
        if (totalBuy === filteredBulkDataList.length) {
            setSelectedBuySellOption(0);
        }
        if (totalBuy === 0) {
            setSelectedBuySellOption(2);
        }
        const totalIntOrder = getTotalCountByKey("IsIntraday", filteredBulkDataList);
        if (totalIntOrder === filteredBulkDataList.length) {
            setSelectedDelIntOption(2);
        }
        if (totalIntOrder === 0) {
            setSelectedDelIntOption(0);
        }
        const totalMktOrder = getTotalCountByKey("AtMarket", filteredBulkDataList);
        if (totalMktOrder === filteredBulkDataList.length) {
            setSelectedMktLmtOption(2);
        }
        if (totalMktOrder === 0) {
            setSelectedMktLmtOption(0);
        }
        if (filteredBulkDataList.length == 0) {
            closeModal();
        }
        setBulkDataList(filteredBulkDataList);
        setUpdateMargin(true);
        ltpRef.current = ltpRef.current.splice(indexValue, 1);
    };
    const toggleExistingPosition = () => {
        setExistingPositionChecked(!existingPositionChecked);
        //setUpdateMargin(true);
    };
    // API calling for Margin Binding for the basket
    const fetchMargin = (bulkDataPayload) => __awaiter(void 0, void 0, void 0, function* () {
        var _b, _c, _d, _e;
        try {
            // For mock data
            // const resultFromMargin = await {data :getPreOrderMarginCalculationBulk()};
            // For live api
            const resultFromMargin = yield preOrdMarginCalculationBulkV3(bulkDataPayload, existingPositionChecked ? "Y" : "N");
            // const resultFromMargin = await {data :getPreOrderMarginCalculationBulk()};
            setAvailableMargin((_c = (_b = resultFromMargin === null || resultFromMargin === void 0 ? void 0 : resultFromMargin.data) === null || _b === void 0 ? void 0 : _b.body) === null || _c === void 0 ? void 0 : _c.AvailableMargin);
            setRequiredMargin((_e = (_d = resultFromMargin === null || resultFromMargin === void 0 ? void 0 : resultFromMargin.data) === null || _d === void 0 ? void 0 : _d.body) === null || _e === void 0 ? void 0 : _e.TotalMargin);
        }
        catch (err) {
            console.error(err);
        }
    });
    const isStoplossValueValid = (stoplossVal, isBuy, limitPrice, atMarket) => {
        if (stoplossVal <= 0)
            return false;
        if (atMarket)
            return true;
        if (isBuy && stoplossVal >= limitPrice)
            return false;
        if (!isBuy && stoplossVal <= limitPrice)
            return false;
        return true;
        // return true;
    };
    useEffect(() => {
        const bulkDataPayload = [];
        bulkDataList.forEach((data) => {
            const singleData = {
                OrderRequestorCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE) || "",
                Exch: data.Exchange,
                ExchType: data.ExchangeType,
                ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE) || "",
                ScripCode: data.ScripCode,
                PlaceModifyCancel: "P",
                TransactionType: data.isBuy === true ? "B" : "S",
                AtMarket: data.AtMarket === true ? "Y" : "N",
                LimitRate: (data === null || data === void 0 ? void 0 : data.AtMarket) === false ? Number(data.Price) : 0,
                Volume: data.Qty,
                OldTradedQty: 0,
                ProductType: "D",
                ExchOrderId: "0",
            };
            bulkDataPayload.push(singleData);
        });
        if (updateMargin) {
            //fetchMargin(bulkDataPayload);
            setUpdateMargin(false);
        }
    }, [bulkDataList]);
    const showAddBasket = (dataForBasket) => {
        const payLoadData = {
            dataArray: [],
        };
        dataForBasket.forEach((data) => {
            const pData = {
                Exchange: data.Exchange,
                ExchangeType: data.ExchangeType,
                Price: data.AtMarket ? 0 : Number(data.Price) * 100,
                OrderType: data.isBuy ? "Buy" : "Sell",
                Qty: data.Qty,
                ScripCode: data.ScripCode,
                AtMarket: data.AtMarket,
                StopLossPrice: 0,
                IsStopLossOrder: false,
                IOCOrder: false,
                DelvIntra: data.IsIntraday ? "I" : "D",
                IsIntraday: data.IsIntraday != false,
                ValidTillDate: new Date().getTime(),
                AHPlaced: "N",
                PublicIP: "0.0.0.0",
                DisQty: 0,
                iOrderValidity: 0,
                AppSource: "21",
                dataArray: [],
            };
            payLoadData.dataArray.push(pData);
        });
        dispatch(openAddToBasketModal(payLoadData));
        closeModal();
    };
    // const checkStrikeRateValidity = async (
    //   value: number,
    //   changedIndex: number,
    //   dataFromBulkOrder?: any
    // ): Promise<void> => {
    //   if (
    //     dataFromBulkOrder !== undefined &&
    //     dataFromBulkOrder[changedIndex] !== undefined &&
    //     dataFromBulkOrder[changedIndex].allowedStrikes !== undefined
    //   ) {
    //     unsubscribeDataBySubscriber(componentName);
    //     const selectedStrikeObj: OptionChainItem | undefined = dataFromBulkOrder[
    //       changedIndex
    //     ].allowedStrikes.find((singleElement) => {
    //       return singleElement.StrikeRate == value;
    //     });
    //     const dataChangedArray = [...dataFromBulkOrder];
    //     if (selectedStrikeObj) {
    //       dataChangedArray[changedIndex].Name = selectedStrikeObj.Name;
    //       dataChangedArray[changedIndex].ScripCode = selectedStrikeObj.ScripCode;
    //       dataChangedArray[changedIndex].LTP = undefined;
    //       dataChangedArray[changedIndex].Price = undefined;
    //       dataChangedArray[changedIndex].lotMessage = undefined;
    //     } else {
    //       dataChangedArray[changedIndex].ScripCode = 0;
    //       dataChangedArray[changedIndex].LTP = undefined;
    //       dataChangedArray[changedIndex].Price = undefined;
    //       dataChangedArray[changedIndex].lotMessage = "Strike not found";
    //     }
    //     setBulkDataList(dataChangedArray);
    //     sendWsMessage(openFeedWsHeartBeat, dataChangedArray);
    //   }
    // };
    const handlePlaceBulkOrder = () => {
        executeOrder(bulkDataList);
        let quantity = 0;
        bulkDataList.map((data) => {
            quantity = quantity + data.Qty;
        });
        captureCleverTabAnalytics("Bulk_Order_Placement", {
            Initiation_Screen: bulkDataList[0].openedFrom,
            Client_Code: clientCode,
            Script_Name: "",
            Exchange: bulkDataList[0].Exchange,
            Order_Type: "",
            Product_Type: "",
            Validity: "",
            Qty: quantity,
            CMP: "",
        });
    };
    useEffect(() => {
        if (bulkDataList) {
            const data = bulkDataList.map((data) => {
                const nameBreakUp = splitAndGetDetailsFromLongName(data.Name);
                const singleElement = {
                    name: nameBreakUp.name,
                    expiry: nameBreakUp.expiry,
                    scripType: nameBreakUp.scripType,
                    strikeRate: nameBreakUp.strikeRate,
                    IsIntraday: data.IsIntraday,
                    OrderType: data.isBuy ? "BUY" : "SELL",
                    Qty: data.Qty,
                    isBuy: data.isBuy,
                    AddReqMgn: 0,
                    AvlbMgn: 0,
                    BrokerOrderID: 0,
                    ClientCode: "",
                    Exch: data.Exchange,
                    ExchOrderID: 0,
                    ExchType: data.ExchangeType,
                    LocalOrderID: 0,
                    Message: "",
                    RMSResponseCode: 0,
                    ScripCode: 0,
                    Status: -1,
                    Time: "",
                    lotMultiplier: lotMultiplier,
                    //NOT IN USE
                };
                return singleElement;
            });
            setBulkOrderSummary(data);
        }
    }, [bulkDataList]);
    useEffect(() => {
        generateSensibullUrl();
    }, [updateMargin]);
    // useEffect(() => {
    //   if (performLoginCheck(false)) {
    //     smartLogin()
    //       .then((result) => {
    //         if (result) {
    //         } else {
    //           setEnableStrategyRoute(false);
    //           console.error("Unable to login");
    //         }
    //       })
    //       .catch((error) => {
    //         setEnableStrategyRoute(false);
    //         alert(error.message);
    //       });
    //   }
    // }, []);
    const toggleSensibullModal = useCallback(() => {
        setSensibullModal(!sensibullModal);
        captureCleverTabAnalytics("Bulk_Order_Placement", {
            Action: "Sensibull_Analyse_Icon",
            // Initiation_Screen: bulkDataList[0].openedFrom,
        });
    }, [sensibullModal]);
    /**
     * Validate The Bulk Data is Of Same Script and Same Exp to enable The route.
     * Sets setEnableStrategyRoute
     * Ignore For Sensex ,BANKEX and MIDCPNIFTY
     */
    useEffect(() => {
        if (bulkDataList.length > 0 && selectedBuySellOption !== 1) {
            selectedBuySellOption === 0
                ? changeBuySell(true, -1)
                : changeBuySell(false, -1);
        }
    }, [selectedBuySellOption]);
    // useEffect(() => {
    //   if (bulkDataList.length > 0 && selectedMktLmtOption !== 1) {
    //     selectedMktLmtOption === 0
    //       ? onMarketLimitChange(false, -1, false)
    //       : onMarketLimitChange(true, -1, false);
    //   }
    // }, [selectedMktLmtOption]);
    const validateStrategyData = () => {
        const newBulkData = bulkDataList.map((item) => {
            const nameBreakup = splitAndGetDetailsFromLongName(item.Name);
            return Object.assign(Object.assign({}, item), { expiry: moment(nameBreakup.expiry).format("YYYY-MM-DD"), symbol: nameBreakup.name });
        });
        const scriptsSelcted = (filterBulkDataList) => {
            const unique_values = filterBulkDataList
                .map((item) => item.symbol + item.expiry)
                .filter((value, index, current_value) => current_value.indexOf(value) === index);
            return unique_values;
        };
        const validateData = scriptsSelcted(newBulkData);
        if (validateData.length == 1) {
            if (validateData[0].includes("SENSEX") ||
                validateData[0].includes("MIDCPNIFTY") ||
                validateData[0].includes("BANKEX")) {
                setEnableStrategyRoute(false);
            }
            else {
                setEnableStrategyRoute(true);
            }
        }
        else {
            setEnableStrategyRoute(false);
        }
    };
    const [tempState, setTempState] = useState(false);
    const onBuySellChange = useCallback((isChecked) => {
        setTempState(isChecked);
    }, []);
    const handleTrippleToggle = useCallback((value) => {
        if (bulkDataList.length > 0 && value !== 1) {
            setSelectedMktLmtOption(value);
            onMarketLimitChange(value === 0 ? false : true, -1, true);
        }
    }, [bulkDataList]);
    //aggregate the combined premium
    //To be added when we have logic available
    // const aggregateCombinedPremium = () => {
    //   const combinedPremium = ltpRef.current.reduce((acc, item) => {
    //     return acc + item;
    //   }, 0);
    //   return setCombinedPrem(combinedPremium);
    // };
    //Take snapshot of ltps and aggregate the combined premium at every 500ms
    //To be added when new logic avaia
    // useEffect(() => {
    //   const interval = setInterval(() => {
    //     aggregateCombinedPremium();
    //   }, 500);
    //   return () => clearInterval(interval);
    // }, [ltpRef.current]);
    const totalSensibullRestrictedItems = bulkDataList.length > 0
        ? bulkDataList.filter((item) => indicesNotAvailableOnSensibull.includes(item.Name.split(" ")[0].toUpperCase())).length
        : 0;
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: styles.modalBodyPart }, { children: [_jsx("div", Object.assign({ className: styles.bulkOrderTableScroll }, { children: _jsxs("table", Object.assign({ className: styles.bulkOrderTable }, { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsxs("th", { children: [_jsx("h6", Object.assign({ className: `${styles.bulkOrderTitle} ${styles.heightHandleTH} mb-0` }, { children: "Bulk Order placement" })), "Contract"] }), _jsxs("th", Object.assign({ className: "textLeft" }, { children: [_jsx("div", Object.assign({ className: `${styles.heightHandleTH}` }, { children: "\u00A0" })), "LTP"] })), _jsxs("th", { children: [_jsx("div", Object.assign({ className: `${styles.heightHandleTH}` }, { children: "\u00A0" })), "Change (%)"] }), _jsxs("th", Object.assign({ className: "" }, { children: [_jsx("div", Object.assign({ className: `${styles.heightHandleTH}` }, { children: _jsx(TripleToggleSwitch, { selectedOption: selectedBuySellOption, checked: tempState, options: tripleToggleOptions.buySell, handleChange: setSelectedBuySellOption }) })), "B/S"] })), _jsxs("th", Object.assign({ className: "textLeft" }, { children: [_jsx("div", Object.assign({ className: `${styles.heightHandleTH}` }, { children: _jsx(TripleToggleSwitch, { selectedOption: selectedDelIntOption, checked: tempState, options: tripleToggleOptions.delInt, handleChange: setSelectedDelIntOption }) })), "Product Type"] })), _jsxs("th", Object.assign({ className: "textLeft bulkOrderStepInput" }, { children: [_jsx("div", Object.assign({ className: `${styles.heightHandleTH}`, style: { visibility: "hidden" } }, { children: _jsx(StepNumberInput, { showMultipler: true, isFocus: false, inputLabel: "", defaultValue: ((_a = props.BulkOrderData[0]) === null || _a === void 0 ? void 0 : _a.multiplierValue) || 1, placeholder: false, disabled: true, stepInput: 1, errorMessage: "Invalid Quantity", 
                                                        // errorMessageCallback={(errMsg) => {}}
                                                        allowZero: false, showError: false, returnValue: (data) => {
                                                            // setDisclosedQuantityCallback(data);
                                                            // changeOrderQty(data, i);
                                                            setLotMultiplier(data);
                                                            const temp = bulkDataList;
                                                            temp.forEach((item, index) => {
                                                                item.Qty = data * item.lotSize;
                                                            });
                                                            setBulkDataList(temp);
                                                        }, minValueAllowed: 1, maxValueAllowed: 100 }) })), "Qty"] })), _jsxs("th", Object.assign({ className: "textLeft" }, { children: [_jsx("div", Object.assign({ className: `${styles.heightHandleTH}` }, { children: _jsx(TripleToggleSwitch, { selectedOption: selectedMktLmtOption, checked: tempState, options: tripleToggleOptions.mktLmt, handleChange: (value) => {
                                                            handleTrippleToggle(value);
                                                        } }) })), "Price"] })), _jsxs("div", Object.assign({ className: `${styles.slTriggerHeader}` }, { children: [_jsx("div", Object.assign({ className: `${styles.closebtnTH} d-flex justify-content-end` }, { children: _jsx("span", { className: "closeIcon", title: "Close", onClick: () => closeModal() }) })), _jsxs("th", Object.assign({ className: `${styles.triggeMinwidth} textLeft` }, { children: [_jsx("div", Object.assign({ className: `${styles.heightHandleTH}` }, { children: "\u00A0" })), "Trigger Price"] })), _jsxs("th", Object.assign({ className: "textRight" }, { children: [_jsx("div", Object.assign({ className: `${styles.heightHandleTH}` }, { children: "\u00A0" })), "Order Type"] }))] })), _jsxs("th", { children: [_jsx("div", Object.assign({ className: `${styles.heightHandleTH}` }, { children: "\u00A0" })), " ", "\u00A0"] })] }) }), _jsx("tbody", { children: _jsx(_Fragment, { children: bulkDataList.map((singleBulk, i) => {
                                        //console.log(singleBulk, "SINGLE BULK--------------");
                                        //Comment
                                        const changePriceValues = getChangeAndChangePercentage(singleBulk.LastTradePrice, singleBulk.prevClose ? singleBulk.prevClose : 0);
                                        const bulkOrderName = singleBulk.Name.split(" ");
                                        return (_jsxs("tr", { children: [_jsx("td", Object.assign({ className: singleBulk.sltErrorMessage ||
                                                        singleBulk.qtyErrorMessage ||
                                                        (!singleBulk.AtMarket &&
                                                            Number(singleBulk.Price) <= 0)
                                                        ? `${styles.errorPadding}`
                                                        : "" }, { children: _jsxs("div", Object.assign({ className: "d-flex align-items-center" }, { children: [_jsx("span", Object.assign({ className: "me-1 mediumWeight large" }, { children: bulkOrderName[0] })), _jsxs("span", Object.assign({ className: "darkGreyText me-1" }, { children: [getDefaultDateFormat(bulkOrderName.slice(1, 3).join(" ")), " "] })), _jsx("span", Object.assign({ className: `${bulkOrderName[3] === "PE"
                                                                    ? "negativeText"
                                                                    : "positiveText"}` }, { children: bulkOrderName[3] ? bulkOrderName[3] : "" })), _jsxs("span", Object.assign({ className: "darkGreyText" }, { children: ["\u00A0", bulkOrderName[4] ? intComma(bulkOrderName[4]) : ""] }))] })) })), _jsxs(_Fragment, { children: [_jsx("td", Object.assign({ className: `${singleBulk.sltErrorMessage ||
                                                                singleBulk.qtyErrorMessage ||
                                                                (!singleBulk.AtMarket &&
                                                                    Number(singleBulk.Price) <= 0)
                                                                ? styles.errorPadding
                                                                : ""}` }, { children: _jsx("div", Object.assign({ className: `${styles.ltpWidth} d-flex` }, { children: singleBulk.Price })) })), _jsx("td", Object.assign({ className: `${singleBulk.sltErrorMessage ||
                                                                singleBulk.qtyErrorMessage ||
                                                                (!singleBulk.AtMarket &&
                                                                    Number(singleBulk.Price) <= 0)
                                                                ? styles.errorPadding
                                                                : ""}` }, { children: _jsx("div", Object.assign({ className: `${styles.ltpDiffWidth} d-flex` }, { children: (changePriceValues === null || changePriceValues === void 0 ? void 0 : changePriceValues.differenceValue) !== undefined &&
                                                                    (changePriceValues === null || changePriceValues === void 0 ? void 0 : changePriceValues.differenceValue) !== null ? (
                                                                // `${changePercentObj?.differenceValue} (${changePercentObj?.differencePercentage})`
                                                                _jsxs(_Fragment, { children: [_jsxs("span", { children: [changePriceValues === null || changePriceValues === void 0 ? void 0 : changePriceValues.differenceValue, " "] }), _jsxs("span", Object.assign({ className: getTextColorFromString(changePriceValues === null || changePriceValues === void 0 ? void 0 : changePriceValues.differencePercentage) }, { children: ["(", changePriceValues === null || changePriceValues === void 0 ? void 0 : changePriceValues.differencePercentage, ")"] }))] })) : (_jsx(Shimmer, {})) })) }))] }), _jsx("td", Object.assign({ className: `${singleBulk.sltErrorMessage ||
                                                        singleBulk.qtyErrorMessage ||
                                                        (!singleBulk.AtMarket &&
                                                            Number(singleBulk.Price) <= 0)
                                                        ? styles.errorPadding
                                                        : ""}` }, { children: _jsxs("div", Object.assign({ className: "editButtonPanel" }, { children: [_jsx("span", Object.assign({ className: singleBulk.isBuy ? "activeBuy" : "", onClick: () => changeBuySell(true, i) }, { children: "Buy" })), _jsx("span", Object.assign({ className: !singleBulk.isBuy ? "activeSell" : "", onClick: () => changeBuySell(false, i) }, { children: "Sell" }))] })) })), _jsx("td", Object.assign({ className: `${singleBulk.sltErrorMessage ||
                                                        singleBulk.qtyErrorMessage ||
                                                        (!singleBulk.AtMarket &&
                                                            Number(singleBulk.Price) <= 0)
                                                        ? styles.errorPadding
                                                        : ""}` }, { children: _jsxs("div", Object.assign({ className: styles.borderButtonPanel }, { children: [_jsx("span", Object.assign({ className: !singleBulk.IsIntraday ? `${styles.active}` : "", onClick: () => changeOrderType(false, i) }, { children: "DEL" })), _jsx("span", Object.assign({ className: singleBulk.IsIntraday ? `${styles.active}` : "", onClick: () => changeOrderType(true, i) }, { children: "INT" }))] })) })), _jsx("td", Object.assign({ className: singleBulk.sltErrorMessage &&
                                                        !singleBulk.qtyErrorMessage
                                                        ? `${styles.errorPadding} textCenter`
                                                        : "textCenter" }, { children: _jsxs("div", Object.assign({ className: `${styles.bulkOrderStepInput} bulkOrderStepInput d-flex align-items-center input-group ` }, { children: [_jsx(StepNumberInput, { isFocus: false, inputLabel: "", defaultValue: singleBulk.lotSize * lotMultiplier, placeholder: false, disabled: singleBulk.lotSize == undefined ||
                                                                    singleBulk.lotSize <= 0, stepInput: singleBulk.Exchange == "M"
                                                                    ? 1
                                                                    : singleBulk.DQty
                                                                        ? singleBulk.DQty
                                                                        : singleBulk.lotSize, errorMessage: "Invalid Quantity", errorMessageCallback: (errMsg) => {
                                                                    singleBulk.qtyErrorMessage = errMsg;
                                                                }, allowZero: false, showError: false, returnValue: (data) => {
                                                                    // setDisclosedQuantityCallback(data);
                                                                    changeOrderQty(data, i);
                                                                }, isBulk: true }), singleBulk.qtyErrorMessage && (_jsxs("p", Object.assign({ className: `${styles.errorText} d-flex align-items-center  mt-2 mb-0 me-3` }, { children: [_jsx("span", { className: "errorIcon" }), singleBulk.qtyErrorMessage] })))] })) })), _jsx("td", Object.assign({ className: singleBulk.sltErrorMessage ||
                                                        singleBulk.qtyErrorMessage ||
                                                        (!singleBulk.AtMarket &&
                                                            Number(singleBulk.Price) <= 0)
                                                        ? `${styles.errorPadding}`
                                                        : "" }, { children: _jsxs("div", Object.assign({ className: "position-relative" }, { children: [_jsxs("div", Object.assign({ className: "d-flex align-items-center" }, { children: [_jsx("span", Object.assign({ className: styles.borderBox }, { children: _jsx("div", Object.assign({ className: "input-group", onClick: () => {
                                                                                if (singleBulk.AtMarket) {
                                                                                    // onMarketLimitChange(false, i); CHECK THIS PRE COMMIT
                                                                                }
                                                                            } }, { children: _jsx("input", { type: "number", placeholder: singleBulk.Price === undefined
                                                                                    ? "Loading..."
                                                                                    : singleBulk.AtMarket
                                                                                        ? `MKT Price`
                                                                                        : "Limit Price", className: `form-control ${!singleBulk.AtMarket
                                                                                    ? Number(singleBulk.Price) <= 0
                                                                                        ? "inputErr"
                                                                                        : ""
                                                                                    : ""}`, "aria-label": "", onWheel: (event) => {
                                                                                    event.target.blur();
                                                                                }, disabled: singleBulk.AtMarket, value: singleBulk.AtMarket
                                                                                    ? "MKT"
                                                                                    : singleBulk.Price + "", step: singleBulk.ExchangeType == "U"
                                                                                    ? "0.0001"
                                                                                    : "0.01", onChange: (event) => onBulkPriceChange(event.target.value, i) }) })) })), _jsxs("div", Object.assign({ className: `${styles.borderButtonPanel} text-capitalize` }, { children: [_jsx("span", Object.assign({ className: singleBulk.AtMarket != true
                                                                                    ? `${styles.active}`
                                                                                    : "", onClick: () => onMarketLimitChange(false, i, false) }, { children: "Limit" })), _jsx("span", Object.assign({ className: singleBulk.AtMarket == true
                                                                                    ? `${styles.active}`
                                                                                    : "", onClick: () => onMarketLimitChange(true, i, false) }, { children: "Market" }))] }))] })), !singleBulk.AtMarket ? (Number(singleBulk.Price) <= 0 ? (_jsxs("p", Object.assign({ className: `${styles.errorText} d-flex align-items-center  mt-2 mb-0 me-3` }, { children: [_jsx("span", { className: "errorIcon" }), "Limit Price should be greater than 0"] }))) : ("")) : ("")] })) })), _jsx("div", Object.assign({ className: `${styles.slTrigger}` }, { children: _jsxs("div", { children: [_jsx("td", Object.assign({ className: `${singleBulk.sltErrorMessage ||
                                                                    singleBulk.qtyErrorMessage ||
                                                                    (!singleBulk.AtMarket &&
                                                                        Number(singleBulk.Price) <= 0)
                                                                    ? styles.errorPadding
                                                                    : ""}` }, { children: _jsxs("div", Object.assign({ className: "position-relative" }, { children: [_jsx("div", Object.assign({ className: "d-flex align-items-center" }, { children: _jsx("span", Object.assign({ className: styles.borderBox }, { children: _jsx("div", Object.assign({ className: "input-group" }, { children: _jsx("input", { type: "number", 
                                                                                        // placeholder={
                                                                                        //   singleBulk.StopLossPrice === undefined
                                                                                        //     ? "Loading..."
                                                                                        //     : `SL Price`
                                                                                        // }
                                                                                        className: `form-control  ${!isStoplossValueValid(singleBulk.StopLossPrice, singleBulk.isBuy, Number(singleBulk.Price), singleBulk.AtMarket)
                                                                                            ? "inputErr"
                                                                                            : ""}`, "aria-label": "", onWheel: (event) => {
                                                                                            event.target.blur();
                                                                                        }, disabled: !singleBulk.IsStopLossOrder, value: singleBulk.IsStopLossOrder
                                                                                            ? singleBulk.StopLossPrice + ""
                                                                                            : "", onChange: (event) => triggerStopLosss(event.target.value, i) }) })) })) })), !isStoplossValueValid(singleBulk.StopLossPrice, singleBulk.isBuy, Number(singleBulk.Price), singleBulk.AtMarket) && (_jsxs("p", Object.assign({ className: `${styles.errorText} d-flex align-items-center  mt-2 mb-0 me-3` }, { children: [singleBulk.sltErrorMessage && (_jsx("span", { className: "errorIcon" })), singleBulk.sltErrorMessage] })))] })) })), _jsx("td", Object.assign({ className: `${singleBulk.sltErrorMessage ||
                                                                    singleBulk.qtyErrorMessage ||
                                                                    (!singleBulk.AtMarket &&
                                                                        Number(singleBulk.Price) <= 0)
                                                                    ? styles.errorPadding
                                                                    : ""}` }, { children: _jsxs("div", Object.assign({ className: `${styles.borderButtonPanel} text-capitalize` }, { children: [_jsx("span", Object.assign({ className: singleBulk.IsStopLossOrder != true
                                                                                ? `${styles.active}`
                                                                                : "", onClick: () => singleBulk.IsStopLossOrder &&
                                                                                stopLossChange(false, i) }, { children: "Regular" })), _jsx("span", Object.assign({ className: singleBulk.IsStopLossOrder == true
                                                                                ? `${styles.active}`
                                                                                : "", onClick: () => {
                                                                                !singleBulk.IsStopLossOrder &&
                                                                                    stopLossChange(true, i);
                                                                                captureCleverTabAnalytics("Bulk_Order_Placement", {
                                                                                    Action: "Order Type Chabged to SL in bulk order",
                                                                                    // Initiation_Screen: bulkDataList[0].openedFrom,
                                                                                });
                                                                            } }, { children: "SL" }))] })) }))] }) })), _jsx("td", Object.assign({ className: `${singleBulk.sltErrorMessage ||
                                                        singleBulk.qtyErrorMessage ||
                                                        (!singleBulk.AtMarket &&
                                                            Number(singleBulk.Price) <= 0)
                                                        ? styles.errorPadding
                                                        : ""}` }, { children: _jsx("div", Object.assign({ className: "d-flex align-items-center" }, { children: _jsx("span", { className: "deleteIconBlue", onClick: () => deleteSingleBulkOrder(i) }) })) }))] }, i));
                                    }) }) })] })) })), _jsxs("div", Object.assign({ className: "buttonWrapper mt-3 mb-2 d-none" }, { children: [_jsx("button", Object.assign({ className: "btnType2 me-2", onClick: () => closeModal() }, { children: "Cancel" })), _jsx("button", Object.assign({ className: "btnType1", 
                            // onClick={() => {
                            //   handlePlaceBulkOrder();
                            //   dispatch(setOrderSummary(true));
                            //   closeModal();
                            //   dispatch(
                            //     openOrderSummary({
                            //       orderResponseData: bulkOrderSummary,
                            //     })
                            //   );
                            // }}
                            onClick: () => dispatch(openGuestLoginModal()), disabled: !isDataValid(bulkDataList) }, { children: "Place order" }))] })), _jsxs("div", Object.assign({ className: `${styles.bottomSummaryPart} mb-3 ` }, { children: [_jsxs("div", Object.assign({ className: "d-flex align-items-center" }, { children: [_jsx("span", Object.assign({ className: `${styles.existingPositions} me-3 ` }, { children: "Incl. existing positions" })), _jsx("span", Object.assign({ className: "mt-n1" }, { children: _jsx(SwitchButton, { checked: existingPositionChecked, onChange: toggleExistingPosition }) })), _jsxs("div", Object.assign({ className: "d-flex align-items-center ms-5" }, { children: [_jsx("span", Object.assign({ className: styles.marginLabel }, { children: "Margin Avail." })), _jsxs("span", Object.assign({ className: "mx-1" }, { children: ["\u20B9 ", convertNumberToShortText(availableMargin), " "] })), _jsx("span", { className: styles.plusIcon, title: "Add funds" })] })), _jsxs("div", Object.assign({ className: "d-flex align-items-center ms-3" }, { children: [_jsx("span", Object.assign({ className: styles.marginLabel }, { children: " Required" })), _jsxs("span", Object.assign({ className: "ms-1" }, { children: ["\u20B9 ", convertNumberToShortText(requiredMargin)] })), _jsx("p", Object.assign({ className: "ms-1 pointer d-flex align-items-center" }, { children: _jsx("span", { className: `${styles.refreshIconBlue} refreshIconBlue ms-2`, onClick: () => setUpdateMargin(true) }) }))] }))] })), isBuyButtonVisible() && (_jsx("div", Object.assign({ className: "d-flex align-items-center" }, { children: _jsx("button", Object.assign({ className: "btnType1 px-5 ms-2", 
                                // onClick={() => {
                                //   executeOrder(bulkDataList);
                                // }}
                                onClick: () => dispatch(openGuestLoginModal()), disabled: !isDataValid(bulkDataList) }, { children: "Place Order" })) })))] })), !isBuyButtonVisible() && _jsx(ActivateSegment, {})] })) }));
};
export default BulkOrder;
